import UserAnalytics from "./Pages/UserAnalytics";

function AnalyticsApp() {
  return <UserAnalytics />;
}

export default AnalyticsApp;
